import { FetchAPI } from "@renedelangel/helpers";

import { urlServidor } from '../../helpers';

// Seguros y siniestros comparten estructura; solo cambia el sufijo (Seg / Sin)
function CrearConsultas(sufijo) {

    const GET = `
        query get($filtro: InputGetCatTipoSeguimiento){
            getCatTipoSeguimiento${sufijo}(filtro: $filtro){
                tipoSeguimientoID
                nombre
                orden
            }
        }`;

    const TABLA = `
        query filtro($filtro: InputFiltroCatTipoSeguimiento){
            filterCatTipoSeguimiento${sufijo}(filtro: $filtro){
                listado{
                    tipoSeguimientoID
                    nombre
                    orden
                }
                registros
                paginas
            }
        }`;

    const get = async (filtro, token) => {
        try {
            let resultado = await FetchAPI.graphql({
                token,
                variables: { filtro },
                url: urlServidor,
                query: GET
            });
            return resultado[`getCatTipoSeguimiento${sufijo}`];
        } catch ({ message }) { throw new Error(message); }
    };

    const tabla = async (variables, token) => {
        try {
            let resultado = await FetchAPI.graphql({
                token,
                variables,
                url: urlServidor,
                query: TABLA
            });
            return resultado[`filterCatTipoSeguimiento${sufijo}`];
        } catch ({ message }) { throw new Error(message); }
    };

    return { get, tabla };
}

const consultasSeg = CrearConsultas("Seg");
const consultasSin = CrearConsultas("Sin");

export const getTipoSeguimientoSeg = consultasSeg.get;
export const tablaTipoSeguimientoSeg = consultasSeg.tabla;
export const getTipoSeguimientoSin = consultasSin.get;
export const tablaTipoSeguimientoSin = consultasSin.tabla;
